import { useState } from 'react'
import styled from 'styled-components/macro'

import { Label, Layout } from '@loadsmart/loadsmart-ui'

import { parseCurrencyValue } from 'core/currency/presenter/CurrencyPresenter'
import { CurrencyField } from 'core/currency/ui/CurrencyField'
import { calculateFlatRate, calculateRatePerDistance } from 'core/domain/LaneRate'

const StyledLayoutGroup = styled(Layout.Group)`
  flex-wrap: nowrap;
`
export type QuoteRateInputFieldsProps = {
  disabled?: boolean
  initialFlatRateValue?: number
  initialRatePerMileValue?: number
  mileage?: number
  onRateChange: (flatRate: number) => void
}

export function QuoteRateInputFields({
  disabled = false,
  mileage,
  onRateChange,
}: QuoteRateInputFieldsProps) {
  const [flatRateValue, setFlatRateValue] = useState<number | null>(null)
  const [ratePerMileValue, setRatePerMileValue] = useState<number | null>(null)

  const hasMileage = Boolean(mileage)
  const disablePerMileRate = disabled || !hasMileage

  function handleFlatRateChange(value: string) {
    if (!value) {
      setRatePerMileValue(null)
      setFlatRateValue(null)
      onRateChange(0)
      return
    }
    const flatRate = parseCurrencyValue(value)
    setFlatRateValue(flatRate)
    if (mileage != null) {
      setRatePerMileValue(calculateRatePerDistance(flatRate, mileage))
    }
    onRateChange(flatRate)
  }

  function handleRatePerMileChange(value: string) {
    if (!value) {
      setRatePerMileValue(null)
      setFlatRateValue(null)
      onRateChange(0)
      return
    }
    const ratePerMile = parseCurrencyValue(value)
    setRatePerMileValue(ratePerMile)
    setFlatRateValue(calculateFlatRate(ratePerMile, mileage!))
    onRateChange(calculateFlatRate(ratePerMile, mileage!))
  }

  return (
    <StyledLayoutGroup space="s">
      <Layout.Stack space="xs">
        <Label id="flat-rate-label" htmlFor="flat-rate">
          Line haul + fuel
        </Label>
        <CurrencyField
          labelledBy="flat-rate-label"
          data-testid="flat-rate"
          placeholder="$"
          onChange={e => handleFlatRateChange(e.target.value)}
          value={flatRateValue}
          disabled={disabled}
        />
      </Layout.Stack>
      {hasMileage && (
        <Layout.Stack space="xs">
          <Label id="rate-per-mile-label" htmlFor="rate-per-mile">
            Rate per mile
          </Label>
          <CurrencyField
            labelledBy="rate-per-mile-label"
            data-testid="rate-per-mile"
            placeholder="$"
            value={ratePerMileValue}
            onChange={e => handleRatePerMileChange(e.target.value)}
            disabled={disablePerMileRate}
          />
        </Layout.Stack>
      )}
    </StyledLayoutGroup>
  )
}
